import { atomFamily, selectorFamily, useRecoilValue } from 'recoil';
export const DEFAULT_LOADER = '@recoil-toolkit.loader.global';
export const loader = atomFamily({
    key: '@recoil-toolkit.loader',
    default: 0,
});
export const isLoading = selectorFamily({
    key: '@recoil-toolkit.loader.isLoading',
    get: (key) => ({ get }) => get(loader(key)) > 0,
});
export const useIsLoading = (key) => useRecoilValue(isLoading(key || DEFAULT_LOADER));
//# sourceMappingURL=loader.js.map